import { createSelector } from 'helpers/reselect'

const getServiceCategorySelector = ({ serviceCategoryDetails } = {}) => serviceCategoryDetails

export const getServiceCategory = createSelector(
  [getServiceCategorySelector],
  ({
    serviceCategory = []
  } = {}) => serviceCategory
)
